import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PortraitService {
  private httpClient = inject(HttpClient);

  portraits = signal<any[]>([]);

  get(category: string) {
    return this.httpClient.get(environment.platformUrl + "api/portrait/list");
  }

  getMine() {
    return this.httpClient.get(environment.platformUrl + "api/portrait").pipe(
      tap(() => console.log("Getting my portrait"))
    );
  }

  getAll() {
    this.httpClient.get(environment.platformUrl + "api/portrait/list")
      .subscribe({
        next: (portraits: any) => {
          this.portraits.set(portraits);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  /**
   * Update Portrait.
   * @param id 
   */
  update(id: number) {
    return this.httpClient.get(environment.platformUrl + "api/portrait/update/" + id);
  }

}
